import {
  HStack,
  Text,
  View,
  VStack,
  ScrollView as GSScrollView,
  Divider
} from "@gluestack-ui/themed";
import { SalesController } from "./controller";
import { Shortcuts } from "@repo/core/components/core/Shortcuts";
import { SalesOptionCard } from "./components/SalesOptionCard";
import { Icon } from "@repo/core/components/core/Icon";
import { SalesSummaryCard } from "./components/SalesSummaryCard";
import { Pressable } from "@gluestack-ui/themed";

import { styles } from "./styles";
import { SalesHomeProps } from "./types";
import { ScrollView } from "@repo/core/components/layout/ScrollView";
import { StoreSelector } from "@repo/core/screens/Sales/components/StoreSelector";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBar } from "@repo/core/components/layout/StatusBar";

function Sales({ showCarrousel }: SalesHomeProps) {
  const {
    TRANSACTIONS_SHORTCUTS,
    OTHER_OPERATIONS_SHORTCUTS,
    MENU_OPTIONS,
    goLeft,
    salesSumaryItems,
    transactionsIsLoading,
    goRight,
    setCurrentPosition,
    isResponsive,
    refScroll,
    selectedStore,
    modalRef,
    handleOnSelectStore,
    enableSelectStore
  } = SalesController();

  return (
    <Scaffolds.StoreSelect
      showHeader={false}
      overrideModalRef={modalRef}
      showSelectStoreBar={false}
    >
      <StatusBar barStyle="light-content" showCustomStatusBar />
      <ScrollView bgColor="$backgroundLight50">
        <View flex={1} bg="$backgroundLight50">
          <VStack
            p="$4"
            space="lg"
            bg="$primary700"
            alignItems="center"
            h={100}
          >
            <Text
              color="$textLight50"
              fontSize="$lg"
              fontWeight="500"
              fontFamily="Inter_500Medium"
              $web-fontFamily="Inter"
            >
              Vendas
            </Text>
            <StoreSelector
              selectedStore={selectedStore}
              onSelectStore={handleOnSelectStore}
              enableSelectStore={enableSelectStore}
            />
          </VStack>
          <HStack bg="$white" p="$4" flex={1} maxHeight={150}>
            <View flex={1} position="relative">
              {showCarrousel && !isResponsive ? (
                <Pressable
                  bg="$white"
                  borderRadius="$full"
                  p="$2"
                  top="35%"
                  shadowColor="$textLight200"
                  shadowOffset={styles.shadowIcons}
                  left={-10}
                  position="absolute"
                  zIndex={500}
                  onPress={goLeft}
                >
                  <Icon name="chevron-left" color="#000000" size={22} />
                </Pressable>
              ) : null}
              <GSScrollView
                ref={(ref) => {
                  // @ts-ignore: Object is possibly 'null'.
                  refScroll.current = ref?.getScrollResponder() || null;
                }}
                onScroll={(event) => {
                  setCurrentPosition(event.nativeEvent.contentOffset.x);
                }}
                horizontal
                showsHorizontalScrollIndicator={false}
                mt="$4"
                pb={!showCarrousel || isResponsive ? null : "$4"}
                mx={!showCarrousel || isResponsive ? null : "$4"}
                gap="$2"
              >
                {salesSumaryItems?.map((item) => (
                  <SalesSummaryCard
                    key={item.title}
                    {...item}
                    isLoading={transactionsIsLoading}
                  />
                ))}
              </GSScrollView>
              {showCarrousel && !isResponsive ? (
                <Pressable
                  bg="$white"
                  borderRadius="$full"
                  p="$2"
                  top="35%"
                  shadowColor="$textLight200"
                  shadowOffset={styles.shadowIcons}
                  position="absolute"
                  right={0}
                  zIndex={500}
                  onPress={goRight}
                >
                  <Icon name="chevron-right" color="#000000" size={22} />
                </Pressable>
              ) : null}
            </View>
          </HStack>

          <HStack
            w="$full"
            flexDirection={isResponsive ? "column" : "row"}
            overflow="hidden"
            justifyContent="center"
            alignItems="center"
            bgColor="$white"
            pb="$4"
            gap={isResponsive ? "$0" : "$24"}
          >
            <VStack
              w={isResponsive ? "$full" : "50%"}
              px="$4"
              space="md"
              alignItems="center"
              $web-md-alignItems="flex-end"
            >
              {TRANSACTIONS_SHORTCUTS.length ? (
                <Shortcuts title="Transações" items={TRANSACTIONS_SHORTCUTS} />
              ) : null}
            </VStack>

            {isResponsive ? (
              <View mx="$4" my="$4" alignItems="center">
                <Divider maxWidth="100%" />
              </View>
            ) : null}

            <VStack
              w={isResponsive ? "$full" : "50%"}
              px="$4"
              alignItems="center"
              $web-md-alignItems="flex-start"
            >
              {OTHER_OPERATIONS_SHORTCUTS.length ? (
                <Shortcuts
                  title="Outras operações"
                  items={OTHER_OPERATIONS_SHORTCUTS}
                />
              ) : null}
            </VStack>
          </HStack>
          <VStack p="$6" space="md">
            {MENU_OPTIONS?.map((salesOption, index) => (
              <SalesOptionCard key={index.toString()} {...salesOption} />
            )) || null}
          </VStack>
        </View>
      </ScrollView>
    </Scaffolds.StoreSelect>
  );
}

export default Sales;
